import styles from "./Join_Early.module.scss";

import { useTranslation } from "react-i18next";

import { PageContainer } from "@/modules/shared/components/PageContainer";

import { AccessCodeIcon } from "../../svgs/AccessCodeIcon";

export function Join_Early() {
  const { t } = useTranslation();

  return (
    <PageContainer variant="constrained">
      <AccessCodeIcon />
      <div className={styles.container}>
        <span className={styles.title}>
          {t("coachingSession.earlyJoin.title")}
        </span>
        <span className={styles.description}>
          {t("coachingSession.earlyJoin.description")}
        </span>
      </div>
    </PageContainer>
  );
}
